module.exports = __webpack_public_path__ + "d308073b/img/pdf-icon.79f04a36.svg";